// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"3e810db3","235":"94e2846b","248":"d7f0ae2d","396":"81cd99ac","453":"e46cf793","464":"de072cd0","562":"2c6868f8","616":"b1c974e4","842":"6a30469d","852":"7900e47b"}[chunkId] + ".chunk.js";
};